(function () {
  'use strict';
  /**
   * @ngdoc object
   * @name agents.edit.controller:EditCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.edit')
    .controller('ProductesMainEditCtrl', ProductesMainEditCtrl);
  function ProductesMainEditCtrl($scope,producteData,$translate,$state,$window, $rootScope,$stateParams,ProducteFactory,Notification,llistaaplicacions) {
    var vm = this;
     var vm = this;
    vm.ctrlName = 'ProductesMainEditCtrl';
    vm.producte=producteData.data;

    vm.listallaplicacions=llistaaplicacions.data.list;

    vm.idProducte = $stateParams.idProducte;
    vm.errors = [];
    vm.isNew = $stateParams.isNew;
    //functions
    vm.back = back;
    if (angular.isUndefined(vm.producte)) {
      vm.producte = {aplicacio:{}};
      vm.disabledlistapp=false;
    }
    else
    {
      vm.disabledlistapp=vm.producte.tevistesdefinides;
    }
    //long vars
    vm.formulari = {
      nom: 'formulariProducte',
      func: func,
      camps: [
            {
              type: 'text',
              name: 'nom',
              label: 'DEFAULT_NOM',
              required: true,
              columns: 6,
              maxLength: 50
            },
            {
              type: 'select',
              name: 'aplicacio',
              label: 'DEFAULT_APLICACIO',
              list:vm.listallaplicacions,
              propertyLabel: 'nom',
              propertyId: 'id' ,
              required: true,
              columns: 6,
              disabled:vm.disabledlistapp
           },
            {
              type: 'text',
              name: 'codiclient',
              label: 'DEFAULT_CODI_client',
              required: false,
              columns: 6,
              maxLength: 50
            },
            {
              type: 'numeric',
              name: 'tedemo',
              label: 'DEFAULT_TEDEMO',
              required: false,
              columns: 6,
              decimalPlaces:0,
              minValue:-1
            }
      ]
    };
    function func() {
      if (vm.isNew) {
        createNew();
      }
      else {
        edit();
      }
    }
    function createNew() {
      ProducteFactory.add(vm.producte).then(function (response) {
        vm.producte.id = response.data;
        $rootScope.$broadcast('productes.main.llista.add', vm.producte);
        HelperFactory.setParams($stateParams, {'idProducte': response.data});
        $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }
    function edit() {
      ProducteFactory.update(vm.idProducte, vm.producte).then(function (response){
      $rootScope.$broadcast('productes.main.llista.update', vm.producte);
      $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain'});
      }).catch(function(error){
        vm.errors = Notification.processError(error);
      });
    }
    function back() {
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
      if ($stateParams.isNew) {
        $state.go('productes.main', $stateParams, {'reload': 'productes.main.submain'});
      }
      else {
        $state.go('productes.main.submain.dades', $stateParams, {'reload': 'productes.main.submain'});
      }
    }
    if (!angular.isUndefined($stateParams.isNew) && $stateParams.isNew !== null && $stateParams.isNew) {
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': false});
    }
    else {
      $rootScope.$broadcast('productes.main.showOptionSubmenu', {'show': true});
    }
  }
}());
